module.exports = __webpack_public_path__ + "static/media/logo-foursquare.da8be88c.svg";